"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityListBanner = exports.EntityListBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_lang_1 = require("../../hooks/use-lang");
var current_path_name_1 = require("../../utils/current-path-name");
var image_fill_1 = require("./image-fill");
var entity_type_title_1 = require("./entity-type-title");
var route_1 = require("../../utils/route");
exports.EntityListBannerDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: 180px;\n    order: 1;\n    width: 100%;\n  "], ["\n    height: 180px;\n    order: 1;\n    width: 100%;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    order: 2;\n    height: 328px;\n    width: 50%;\n    max-width: 592px;\n  "], ["\n    order: 2;\n    height: 328px;\n    width: 50%;\n    max-width: 592px;\n  "]))),
  desktopLarge: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: 792px;\n  "], ["\n    max-width: 792px;\n  "]))),
  desktop4Column: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    max-width: 900px;\n  "], ["\n    max-width: 900px;\n  "]))),
  desktop5Column: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    max-width: 1330px;\n    height: 380px;\n  "], ["\n    max-width: 1330px;\n    height: 380px;\n  "])))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    order: 2;\n  "], ["\n    order: 2;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    padding: ", ";\n    padding-top: 0;\n    flex-grow: 1;\n    order: 1;\n  "], ["\n    padding: ", ";\n    padding-top: 0;\n    flex-grow: 1;\n    order: 1;\n  "])), theme_1.theme.UNIT(3)),
  desktop: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: ", ";\n\n  "], ["\n    padding: ", ";\n\n  "])), theme_1.theme.UNIT(3))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-top: ", ";\n    ", ";\n    padding-top: ", ";\n\n  "], ["\n    margin-top: ", ";\n    ", ";\n    padding-top: ", ";\n\n  "])), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3, 2))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    color: ", ";\n    line-height: 1.45em;\n    margin-bottom: 0;\n  "], ["\n    color: ", ";\n    line-height: 1.45em;\n    margin-bottom: 0;\n  "])), theme_1.theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: (0, styled_components_1.default)(entity_type_title_1.EntityTypeTitle)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled_components_1.default.p(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Controls: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  Image: (0, styled_components_1.default)(image_fill_1.ImageFill)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
var EntityListBanner = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    latest = props.latest;
  var t = (0, use_lang_1.useLang)();
  var from = (0, current_path_name_1.currentPathName)();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  if (!definition) {
    return null;
  }
  var list = definition.list;
  var editRoute = (0, route_1.route)(definition.paths.update, {
    id: latest && latest.id,
    _trailing: "from".concat(from)
  });
  var to = definition.routes.details ? definition.to(latest && latest.slug) : editRoute;
  var desc = t(list.banner.content);
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Title, {
    size: "veryLarge",
    entityTypeName: entityTypeName
  }), desc && react_1.default.createElement(My.Description, null, desc)));
};
exports.EntityListBanner = EntityListBanner;
exports.EntityListBanner.defaultProps = exports.EntityListBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;